var _rect, _path, _path2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialWechatRound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#5BC78C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.611 12.5c-3.474-.05-6.361 2.4-6.361 5.288 0 1.668.818 3.114 2.4 4.176 0 0-.58 1.837-.572 1.873.008.037.135.11.179.086l2.096-1.198c1.471.484 2.368.365 2.522.345a.409.409 0 01.02-.003 3.682 3.682 0 01-.142-1.774c.613-3.387 4.228-4.441 6.209-4.261-.547-2.446-2.923-4.482-6.35-4.531zm-2.415 2.78c-.455 0-.825.355-.825.793 0 .437.37.791.825.791.456 0 .826-.354.826-.791 0-.438-.37-.792-.826-.792zm4.996 0c-.456 0-.825.355-.825.793 0 .437.37.791.825.791.456 0 .825-.354.825-.791 0-.438-.369-.792-.825-.792z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.048 21.808c0-2.475-2.495-4.37-5.389-4.37-3.064 0-5.508 1.938-5.508 4.413 0 2.479 2.324 4.53 5.512 4.548.641.003 1.596-.155 2.24-.413 0 0 1.54.895 1.627.889a.14.14 0 00.134-.128c.003-.057-.49-1.455-.49-1.455 1.322-.994 1.874-2.088 1.874-3.484zm-7.406-2.317c-.403 0-.73.314-.73.702 0 .387.327.701.73.701.403 0 .73-.314.73-.701 0-.388-.327-.702-.73-.702zm3.904 0c-.403 0-.73.314-.73.702 0 .387.327.701.73.701.403 0 .73-.314.73-.701 0-.388-.327-.702-.73-.702z",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 39.5,
    height: 39.5,
    rx: 19.75,
    stroke: "#000",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })));
}
export default SvgSocialWechatRound;